module.exports = __webpack_public_path__ + "img/values-img.053be788.svg";